export interface IUcumCode {
  ucumCodesId: string;
  code: string;
  descriptionEnglish: string;
  descriptionArabic: string;
}

export const ucumCodeconfig = {
  entityName: 'CONFIGURATION.UCUM_CODE.TITLE',
  code: 'FORM_FIELD.CODE',
  descriptionEnglish: 'FORM_FIELD.ENGLISH_DESCRIPTION',
  descriptionArabic: 'FORM_FIELD.ARABIC_DESCRIPTION',
};